import { ReactComponent as Edit } from './icon.svg'

export default Edit
